import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { CraftEntity, CreateCraftEntity } from '../models/craft-entity.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CraftEntityService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readCraftEntities(): Observable<CraftEntity[]> {
    return this.#http.getData(`${this.baseUrl}/crafts`, { showLoader: true, showMessage: false });
  }

  readCraftEntityById(id: string): Observable<CraftEntity> {
    return this.#http.getData(`${this.baseUrl}/crafts/${id}`, { showLoader: true, showMessage: false });
  }

  createCraftEntity(craftEntity: CreateCraftEntity): Observable<unknown> {
    return this.#http.postData(`${this.baseUrl}/crafts`, { showLoader: true, showMessage: true }, craftEntity);
  }

  updateCraftEntity(craftEntity: CreateCraftEntity, id: string): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/crafts/${id}`, craftEntity, { showLoader: true, showMessage: true });
  }

  deleteCraftEntity(id: string): Observable<unknown> {
    return this.#http.deleteData(`${this.baseUrl}/crafts/${id}`, { showLoader: true, showMessage: true });
  }
}
